import { type Automation, type FlowStep } from '@spike/automation-model';
import {
    uid,
    formatDelayLabel,
    formatSmsSubtitle,
    formatEmailSubtitle,
    DEFAULT_UNSUBSCRIBE_MESSAGE,
    DEFAULT_SENDER_NAME,
    DEFAULT_SENDER_EMAIL
} from '../Canvas/useAutomationFlow';
import { type AutomationTemplate, type TemplateStep } from './automationTemplates';

export const automationFromTemplate = (template: AutomationTemplate): Automation => ({
    id: '',
    name: template.name,
    status: 'draft',
    trigger: template.trigger,
    steps: template.steps.map(toFlowStep),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
});

const toFlowStep = (step: TemplateStep): FlowStep => {
    switch (step.type) {
        case 'delay': {
            const amount = step.amount ?? 1;
            const unit = step.unit ?? 'days';

            return {
                id: uid(),
                type: 'delay',
                label: formatDelayLabel(amount, unit),
                subtitle: '',
                amount,
                unit,
                extraMinutes: 0
            };
        }

        case 'sms': {
            const message = step.message ?? '';

            return {
                id: uid(),
                type: 'sms',
                label: 'Send SMS',
                subtitle: formatSmsSubtitle(message),
                smsName: '',
                content: {
                    message,
                    unsubscribeMessage: DEFAULT_UNSUBSCRIBE_MESSAGE
                },
                skipCampaign: false,
                skipFlow: false,
                dayOffset: 0
            };
        }

        case 'email': {
            const subject = step.subject ?? '';

            return {
                id: uid(),
                type: 'email',
                label: 'Send Email',
                subtitle: formatEmailSubtitle(subject),
                emailName: '',
                subjectLine: subject,
                previewText: '',
                senderName: DEFAULT_SENDER_NAME,
                senderEmail: DEFAULT_SENDER_EMAIL,
                useAsReplyTo: false,
                skipRecentlyEmailed: false,
                dayOffset: 0
            };
        }
    }
};
